import {
  LOADINGMAIN_CLOSE,
  LOADINGMAIN_OPEN,
} from "./types";

export const openLoadingMain = (config) => async (dispatch) => {
  dispatch({ 
    type: LOADINGMAIN_OPEN,
    payload: {
      shape: (config && config.shape) || "circle",
      text: (config && config.text) || null,
      maxWidth: (config && config.maxWidth) || null
    }, 
  });
};

export const closeLoadingMain = () => async (dispatch) => {
  dispatch({ type: LOADINGMAIN_CLOSE });
};
